export default __webpack_public_path__ + "static/media/cloth.ed154d12.jpg";